<template>
  <div>
    <NavBar titleTranslationPath="more.title" back commune :login-status="!!communeSelected" />
    <div class="content">
      <section v-if="communeSelected" class="genericoptions">
        <Button
          @click.native="$router.push({ name: $namedRoutes.feedback })"
          color="green"
          center
          path="more.feedback.button"
        ></Button>
      </section>
      <!-- Homepage Link -->
      <router-link :to="{ name: $namedRoutes.splash }">
        <ButtonPanel>
          <NewTranslation path="more.splash.label" slot="headline" />
        </ButtonPanel>
      </router-link>
      <!-- Language Setting -->
      <CollapsiblePanel :initial-is-open="tabOpen === 'settings'">
        <NewTranslation path="more.language.label" slot="headline" />
        <section slot="body" class="body-section">
          <ul class="language-list">
            <li @click="switchLocale('de')">
              <NewTranslation path="more.language.german" />
              <div class="icon" v-if="locale === 'de'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('en')">
              <NewTranslation path="more.language.english" />
              <div class="icon" v-if="locale === 'en'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('es')">
              <NewTranslation path="more.language.spanish" />
              <div class="icon" v-if="locale === 'es'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('it')">
              <NewTranslation path="more.language.italian" />
              <div class="icon" v-if="locale === 'it'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('fr')">
              <NewTranslation path="more.language.french" />
              <div class="icon" v-if="locale === 'fr'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('dk')">
              <NewTranslation path="more.language.danish" />
              <div class="icon" v-if="locale === 'dk'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('nl')">
              <NewTranslation path="more.language.dutch" />
              <div class="icon" v-if="locale === 'nl'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
            <li @click="switchLocale('cz')">
              <NewTranslation path="more.language.czech" />
              <div class="icon" v-if="locale === 'cz'">
                <font-awesome-icon icon="check-circle" />
              </div>
            </li>
          </ul>
        </section>
      </CollapsiblePanel>
      <!-- Commune Conditions -->
      <CollapsiblePanel
        v-if="communeSelected && communeInfo.terms && communeInfo.terms.conditions"
        class="profile-tab-terms"
      >
        <NewTranslation path="more.conditions.label" slot="headline" />
        <section v-html="communeInfo.terms.conditions" slot="body" class="body-section" />
      </CollapsiblePanel>
      <!-- Help Section -->
      <CollapsiblePanel v-if="communeSelected">
        <NewTranslation path="more.help.label" slot="headline" />
        <section slot="body" class="body-section">
          <section
            v-if="communeSelected && communeInfo.terms && communeInfo.terms.help"
            v-html="communeInfo.terms.help"
          ></section>
          <NewTranslation v-else path="commune.terms.help" />
        </section>
      </CollapsiblePanel>
      <!-- New Terms and Conditions -->
      <CollapsiblePanel :initial-is-open="tabOpen === 'terms'">
        <NewTranslation path="more.termsAndConditions.label" slot="headline" />
        <section slot="body" class="body-section">
        <CollapsiblePanel :is-inside-panel="true" :initial-is-open="tabOpen === 'termsLocal'">
          <NewTranslation path="more.termsAndConditions.local.label" slot="headline" />
          <section slot="body" class="body-section">
            <NewTranslation path="commune.terms.termsAndConditions" />
          </section>
        </CollapsiblePanel>
        <CollapsiblePanel v-if="communeSelected && communeInfo.terms && communeInfo.terms.terms_and_conditions" :is-inside-panel="true" :initial-is-open="tabOpen === 'termsCommune'">
          <NewTranslation
              slot="headline"
              path="more.termsAndConditions.commune.label"
              :params="{ commune: communeInfo && communeInfo.name }"
          ></NewTranslation>
          <section slot="body" class="body-section">
            <section v-html="communeInfo.terms.terms_and_conditions"></section>
          </section>
        </CollapsiblePanel>        
        </section>
      </CollapsiblePanel>
      <!-- New Privacy Terms -->
      <CollapsiblePanel :initial-is-open="tabOpen === 'privacy'">
        <NewTranslation path="more.privacyTerms.label" slot="headline" />
        <section slot="body" class="body-section">
          <CollapsiblePanel :is-inside-panel="true" :initial-is-open="tabOpen === 'privacyLocal'">
            <NewTranslation path="more.privacyTerms.local.label" slot="headline" />
            <section slot="body" class="body-section">
              <NewTranslation path="commune.terms.privacyTerms" />
            </section>
          </CollapsiblePanel>
          <CollapsiblePanel v-if="communeSelected && communeInfo.terms && communeInfo.terms.privacy_terms" :is-inside-panel="true" :initial-is-open="tabOpen === 'privacyCommune'">
            <NewTranslation
                slot="headline"
                path="more.privacyTerms.commune.label"
                :params="{ commune: communeInfo && communeInfo.name }"
            ></NewTranslation>            
            <section slot="body" class="body-section">
              <section v-html="communeInfo.terms.privacy_terms"></section>
            </section>
          </CollapsiblePanel>
        </section>
      </CollapsiblePanel>
      <!-- Imprint -->
      <CollapsiblePanel :initial-is-open="tabOpen === 'imprint'">
        <NewTranslation path="more.imprint.label" slot="headline" />
        <section slot="body" class="body-section">
          <section
            v-if="communeSelected && communeInfo.terms && communeInfo.terms.imprint"
            v-html="communeInfo.terms.imprint"
          ></section>
          <NewTranslation v-else path="commune.terms.imprint" />
        </section>
      </CollapsiblePanel>
      <!-- Cancellation -->
      <CollapsiblePanel v-if="communeSelected && communeInfo.terms && communeInfo.terms.cancellation_text">
        <NewTranslation path="more.contact.label" slot="headline" />
        <section slot="body" class="body-section" v-html="communeInfo.terms.cancellation_text" />
      </CollapsiblePanel>
      <!-- Transaction Validation -->
      <section v-if="communeSelected" class="genericoptions">
        <router-link
          :to="{
            name: $namedRoutes.transactionOverview,
            query: {
              openFirstValidTicket: true,
            },
          }"
        >
          <Button path="more.control.button" :color="hasValidTicket ? 'green' : 'gray'" center />
        </router-link>
      </section>
      <!-- Version -->
      <section class="versions">
        <div class="version-entry">API: v{{ $store.state.api.version }}</div>
        <div class="version-entry">App: v{{ $store.state.app.version }}</div>
      </section>
    </div>
    <TabBar v-if="communeSelected" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import Button from '@/components/Button.vue';
import NewTranslation from '@/components/i18n/NewTranslation';
import CollapsiblePanel from '@/components/CollapsablePanel';
import ButtonPanel from '@/components/ButtonPanel';

export default {
  components: {
    ButtonPanel,
    CollapsiblePanel,
    NewTranslation,
    NavBar,
    TabBar,
    Button,
  },
  data() {
    return {
      tabOpen: this.$route.query.tabOpen,
    };
  },
  mounted() {
    this.$store.dispatch('fetchApiInfo');
  },
  methods: {
    ...mapActions('i18n', ['switchLocale']),
  },
  computed: {
    ...mapGetters(['communeInfo', 'hasValidTicket', 'communeSelected']),
    ...mapGetters('i18n', ['locale']),
  },
};
</script>

<style lang="sass" scoped>
.body-section
  padding-top: 20px
  padding-bottom: 20px
  color: #454F63
  word-break: break-word

  & + &
    border-top: 1px solid #F4F4F6

  a
    color: #1DB2D1

.content
  padding: 20px 20px 100px
  background-color: #F3F7F8
  min-height: calc(100vh - 92px)

  ul.language-list
    margin: 0
    padding: 0

    li
      display: flex
      align-items: center
      justify-content: space-between
      padding: 20px
      border-bottom: 1px solid #F3F7F8
      list-style: none

      &:first-child
        margin-top: -10px

      &:last-child
        border-bottom: none

      .icon
        font-size: 20px
        color: #1DB2D1

.versions
  font-size: .8rem
  margin-top: 1rem
  text-align: center

.version-entry
  display: inline-block
  color: #454f63

.version-entry + .version-entry
  margin-left: 1rem
</style>
